import {
    getAvailabeCases,
    AuditCaseReportView,
    AuditCaseReportDownload
  } from '../Services/case';

  
  const getAvailabeCasesAction = async (id) => {
    const result = await getAvailabeCases(id);
   // store.dispatch(setAllOrders(result.data));
    return result;
  };
  
  const AuditCaseReportViewAction = async (data) => {
    const result = await AuditCaseReportView(data);
    return result;
  };

  const AuditCaseReportDownloadAction = async (data) => {
    const result = await AuditCaseReportDownload(data);
    return result;
  };
  
  export {
    getAvailabeCasesAction,
    AuditCaseReportViewAction,
    AuditCaseReportDownloadAction
  };
  